import React, { useEffect, useState } from "react";
import { BadgePercent, X } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { getStoredRef } from "@/lib/referral";
import { eur } from "@/data/ambassadorProgramme";

export const AMBASSADOR_COURSES = ["CSCE-EXAM", "CSP-EXAM"];

export const AmbassadorDiscount = ({ course, discount, onChange }) => {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const apply = async (c) => {
    if (!c) return;
    setBusy(true); setErr("");
    try {
      const { data } = await api.get("/ambassadors/validate", { params: { code: c.trim(), course_id: course.id } });
      if (!data.available) { setErr("Ambassador pricing is temporarily unavailable for this programme."); onChange(null); }
      else onChange(data);
    } catch (e) { setErr(formatApiError(e.response?.data?.detail)); onChange(null); }
    finally { setBusy(false); }
  };

  useEffect(() => {
    const r = getStoredRef();
    if (r) { setCode(r.code); apply(r.code); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course.id]);

  if (discount) return (
    <div className="mt-4 rounded-xl border border-emerald-300 bg-emerald-50 p-3 text-xs" data-testid="ambassador-discount-applied">
      <div className="flex items-center justify-between gap-2">
        <span className="inline-flex items-center gap-1 font-semibold text-emerald-800"><BadgePercent size={14}/> {discount.code} applied</span>
        <button type="button" onClick={() => { onChange(null); setCode(""); }} className="text-emerald-800 hover:opacity-70" aria-label="Remove code" data-testid="ambassador-discount-remove"><X size={14}/></button>
      </div>
      <div className="mt-1 text-emerald-900" data-testid="ambassador-discount-savings">
        <s className="opacity-60">{eur(discount.price)}</s> <b>{eur(discount.discounted_price)}</b> · You save {eur(discount.savings)} ({discount.discount_pct}%), courtesy of CSI Ambassador {discount.ambassador}
      </div>
    </div>
  );
  return (
    <form onSubmit={(e) => { e.preventDefault(); apply(code); }} className="mt-4" data-testid="ambassador-discount-form">
      <label className="text-xs font-semibold text-zinc-600">Ambassador code (5% off)</label>
      <div className="flex gap-2 mt-1">
        <input className="field flex-1 min-w-0 uppercase text-sm" placeholder="CSI-NAME" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} data-testid="ambassador-discount-input"/>
        <button disabled={busy || !code} className="chip text-xs disabled:opacity-50" data-testid="ambassador-discount-apply">{busy ? "…" : "Apply"}</button>
      </div>
      {err && <div className="text-xs text-red-700 mt-1" data-testid="ambassador-discount-error">{err}</div>}
    </form>
  );
};
